import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LanguageService } from './language.service';
import { detectPreferredLang, isAppLang } from './languages';

@Injectable({ providedIn: 'root' })
export class LangGuard implements CanActivate {
  private readonly language = inject(LanguageService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const lang = route.paramMap.get('lang');
    if (!isAppLang(lang)) {
      const preferred = detectPreferredLang();
      const rest = route.url.map((s) => s.path).join('/');
      return this.router.createUrlTree(rest ? [preferred, rest] : [preferred]);
    }
    this.language.syncFromUrl(lang);
    return true;
  }
}

@Injectable({ providedIn: 'root' })
export class PrefixedLangRedirectGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree {
    const lang = detectPreferredLang();
    const url = state.url.split('?')[0];
    const path = url === '/' ? '' : url;
    return this.router.parseUrl(`/${lang}${path}`);
  }
}
